import { Injectable } from "@angular/core";
import { LoggerService } from "../../infra/logger/logger.service";
import { HttpService } from "../http/http.service";
import { JsonHalCollection } from "src/app/models/api/jsonhal.model";
import { CreateLabelModel, EditLabelModel, LabelModel, LabelModelWithLinks } from "src/app/models/api/common";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class LabelsHttpService {
    public readonly defaultPageSize: number = 50;
    private readonly _baseUrl: string = "labels";

    constructor(
        private _httpService: HttpService,
        private _logger: LoggerService,
    ) {}

    /**
     * @public Get labels
     * @returns an Observable{LabelModel} with the labels returned from server
     */
    public getLabels(): Observable<JsonHalCollection<LabelModel>> {
        const url = `${this._baseUrl}`;
        return this._httpService.get<JsonHalCollection<LabelModel>>(url, undefined);
    }

    public createLabel(label: CreateLabelModel): Observable<LabelModelWithLinks> {
        const url = `${this._baseUrl}`;
        return this._httpService.post<CreateLabelModel, LabelModelWithLinks>(url, label);
    }

    public deleteLabel(labelId: string): Observable<void> {
        const url = `${this._baseUrl}/${labelId}`;
        return this._httpService.delete<void>(url);
    }

    public editLabel(label: LabelModel): Observable<void> {
        const url = `${this._baseUrl}/${label.id}`;
        const newBody = {
            displayName: label.displayName,
            color: label.color,
        } as EditLabelModel;
        return this._httpService.patch<EditLabelModel, void>(url, newBody);
    }
}
